import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBookmarkCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bookmark-check, add, check"} maskId="square-filled-radius-0-stroke-1-IconBookmarkCheck"><path fillRule="evenodd" clipRule="evenodd" d="M4 21.8333V2H20V21.8333L12 17.5667L4 21.8333ZM15.9071 7.89999L15.2 7.19289L11 11.3929L9.2 9.59288L8.49289 10.3L11 12.8071L15.9071 7.89999Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBookmarkCheck;
